import { getBaseUrl } from '@/helpers/getBaseUrl';
import { getPageHierarchyList } from '@/lib/getPageHierarchyList';
import { PageDataType } from '@/lib/getPageHierarchyList';

export type BreadcrumbsType = {
    title: string;
    url: string;
};

export function getBreadcrumbs(page: PageDataType): BreadcrumbsType[] {
    const pageHierarchyList = getPageHierarchyList(page);
    if (!pageHierarchyList || !pageHierarchyList.length) {
        return [];
    }
    let parentUrl = `${pageHierarchyList[0].countryCode}`;
    const hostname = getBaseUrl();
    const breadcrumbs = [{ title: `Home ${String(pageHierarchyList[0].countryCode).toUpperCase()}`, url: `${hostname}/${parentUrl}` }];
    for (const page of pageHierarchyList) {
        parentUrl = `${parentUrl}/${page.slug}`;
        breadcrumbs.push({
            title: page.title,
            url: `${hostname}/${parentUrl}`,
        });
    }
    return breadcrumbs;
}
